"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsContainer = exports.StyledList = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var TabsContainer = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    .react-tabs__tab-list {\n        display: flex;\n        padding: 0;\n        list-style-type: none;\n        margin-bottom: 1rem;\n        flex-wrap: wrap;\n    }\n\n    .react-tabs__tab {\n        display: inline-block;\n        padding: 5px 0;\n        border-bottom: 2px solid transparent;\n        margin-right: 1.5rem;\n        font-weight: 500;\n        cursor: pointer;\n    }\n\n    .react-tabs__tab--selected {\n        color: ", ";\n        border-bottom-color: ", ";\n    }\n"])), function (props) {
  return props.theme.admin.colors.brand;
}, function (props) {
  return props.theme.admin.colors.brand;
});

exports.TabsContainer = TabsContainer;

var StyledList = _styledComponents["default"].ul(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding-left: 1rem;\n\n    li {\n        position: relative;\n        list-style-type: none;\n        margin-bottom: 10px;\n\n        &:before {\n            content: '';\n            height: 8px;\n            width: 8px;\n            background-color: ", ";\n            display: inline-block;\n            position: absolute;\n            left: -15px;\n            top: 6px;\n            border-radius: 50%;\n        }\n    }\n"])), function (props) {
  return props.theme.admin.colors.brand;
});

exports.StyledList = StyledList;